<div class="edit-form" style="padding: 40px;">
    <div class="row">
        <div class="col-12 m-b-25 d-flex flex-column">
            <div class="d-flex align-items-center">
                <h5 class="font-weight-bold" style="font-size: 26px;">Chi tiết Mail</h5>
            </div>
            <div class="row" style="margin-left: 15px;">
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label"><span class="field-label"></span>Loại</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.type?.name}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">Chủ đề</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.subject}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">Nội dung</label>
                    <div class="col-6">
                        <p [innerHTML]="detailObject.content"></p>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">Loại thông báo</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.category}}</span>
                    </div>
                </div>

                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">Danh sách NĐT gửi thông báo</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.textList}}</span>
                    </div>
                </div>

                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">Hẹn giờ</label>
                    <div class="col-6">
                        <span class="field-value" *ngIf="!detailObject.filterReceiver?.scheduledTime">N/A</span>
                        <span class="field-value" *ngIf="detailObject.filterReceiver?.scheduledTime">Ngày
                            {{detailObject.filterReceiver?.scheduledTime | date: 'dd/MM/yyyy, hh:mm'}}</span>
                    </div>
                </div>
                <!-- <div class="col-12 m-b-25 row" *ngIf="!filterReceiver?.isAllInvestor">
                    <label class="col-6 field-label d-flex align-items-center">
                        Bộ lọc
                        <i nz-icon class="ml-2" nzType="setting" nzTheme="outline"></i>
                    </label>
                </div> -->
            </div>
            <!-- <div class="row" style="width: 1000px; margin-left: 50px;" *ngIf="!filterReceiver?.isAllInvestor">
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Bộ Email chỉ định</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.receivers || 'N/A'}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Sở hữu tài sản</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.filterReceiver?.isHaveAsset === null ? 'Tất cả' :
                            (detailObject.filterReceiver?.isHaveAsset ? 'Có tài sản' : 'Không tài sản')}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Tổ chức phát hành</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.issuers || 'N/A'}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Sản phẩm sở hữu</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.products || 'N/A'}}</span>
                    </div>
                </div>

                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Top Asset Percent (%)</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.filterReceiver?.topAssetPercent || 'N/A'}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Top Buying Percent (%)</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.filterReceiver?.topBuyingPercent || 'N/A'}}</span>
                    </div>
                </div>

                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Tỉnh</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.provinces || 'N/A'}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Tình Trạng</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.kycStatusCode || 'N/A'}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Trạng thái</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.crmStatus || 'N/A'}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Giới tính</label>
                    <div class="col-6">
                        <span class="field-value">{{detailObject.filterReceiver?.gender === null ? 'Tất cả' :
                            (detailObject.filterReceiver?.gender ? 'Nam' : 'Nữ')}}</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Độ tuổi</label>
                    <div class="col-6">
                        <span class="field-value">Từ {{detailObject.filterReceiver?.startAge}} đến
                            {{detailObject.filterReceiver?.endAge}} tuổi</span>
                    </div>
                </div>
                <div class="col-12 m-b-25 row">
                    <label class="col-6 field-label">- Ngày active Investor</label>
                    <div class="col-6">
                        <span class="field-value"
                            *ngIf="detailObject.filterReceiver?.activeStart && detailObject.filterReceiver?.activeEnd">
                            Từ {{detailObject.filterReceiver?.activeStart | date: 'dd/MM/yyyy'}} đến
                            {{detailObject.filterReceiver?.activeEnd | date: 'dd/MM/yyyy'}}</span>
                        <span class="field-value"
                            *ngIf="detailObject.filterReceiver?.activeStart && !detailObject.filterReceiver?.activeEnd">
                            Từ {{detailObject.filterReceiver?.activeStart | date: 'dd/MM/yyyy'}} đến hiện tại</span>
                        <span class="field-value"
                            *ngIf="!detailObject.filterReceiver?.activeStart && detailObject.filterReceiver?.activeEnd">
                            Từ {{detailObject.filterReceiver?.activeEnd | date: 'dd/MM/yyyy'}} trở về trước</span>
                        <span class="field-value"
                            *ngIf="!detailObject.filterReceiver?.activeStart && !detailObject.filterReceiver?.activeEnd">
                            N/A</span>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>